import { updateStatusBarColor } from 'utils/updateStatusBarColor'
import { FreeMode, Navigation, Thumbs } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import React, { useEffect, useState } from 'react'
import PublishModal from './PublishModal'
import VideoWrapper from './VideoWrapper'
import DeleteModal from './DeleteModal'
import SwiperCore from 'swiper'

import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import 'swiper/css/thumbs'

interface SwiperGalleryModalProps {
  fromPublic?: boolean
  initialSlide: number
  data: board.Gallery[]
  onClose: () => void
  onReload?: () => void
}

const style = {
  '--swiper-navigation-color': '#ffffff',
  '--swiper-pagination-color': '#ffffff',
} as React.CSSProperties

const SwiperGalleryModal: React.FC<SwiperGalleryModalProps> = ({ data, fromPublic, initialSlide, onClose, onReload }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperCore | null>(null)
  const [mainImageIsPublished, setMainImageIsPublished] = useState<boolean>(true)
  const [isVideoLoading, setVideoLoading] = useState<boolean>(true)
  const [currentSlideIndex, setCurrentSlideIndex] = useState<number>(initialSlide)
  const [modal, setModal] = useState<string>('')
  const [action, setAction] = useState<string>('')
  const [mediaId, setMediaId] = useState<string>('')

  const gallery = data && data.map(({ displayName, url, isVideo, cdnStatus }, idx) => (
    <SwiperSlide key={idx}>
      {isVideo ? (
        cdnStatus === 'SUCCESS' ? (<>
          <div className={`loader ${isVideoLoading && 'action'}`}>
            <i className='icon icon--pending'></i>
            <span> Ładowanie...</span>
          </div>
          <VideoWrapper url={url} setVideoLoading={setVideoLoading} />
        </>
        ) : cdnStatus === 'ERROR' ? (
          <div className='text'>Do ponowienia</div>
        ) : cdnStatus === 'PENDING' || cdnStatus === 'INIT' ? (
          <div className='text'>Ładowanie...</div>
        ) : null
      ) : (
        <div className="image-wrapper">
          <img src={url} alt={displayName} />
        </div>
      )}
    </SwiperSlide>
  ))

  const thumbsGallery = data && data.map(({ displayName, thumbnailUrl }, idx) => (
    <SwiperSlide key={idx}>
      <div className="image-wrapper">
        <img src={thumbnailUrl} alt={displayName} />
      </div>
    </SwiperSlide>
  ))

  const handleSlideChange = (swiper: SwiperCore) => {
    let realIndex = swiper.realIndex
    setCurrentSlideIndex(realIndex)
  }

  const handleAction = (action: string, id: string) => {
    setMediaId(id)
    setAction(action)
    if (action === 'delete') {
      setModal('delete')
    } else {
      setModal('publish')
    }
  }

  useEffect(() => {
    const handlePopState = () => {
      if (onClose) {
        onClose();
      }
    };
  
    // Ustawienie historii, gdy modal jest otwarty
    window.history.pushState({ isModalOpen: true }, '');
    
    window.addEventListener('popstate', handlePopState);
  
    return () => {
      window.removeEventListener('popstate', handlePopState);
      // Tylko w przypadku, gdy stan historii to isModalOpen, cofnięcie
      if (window.history.state && window.history.state.isModalOpen) {
        window.history.back();
      }
    };
  }, [onClose]);
  
  useEffect(() => {
    if (data === undefined || data.length === 0) {
      onClose()
    }
  }, [data, onClose, onReload])


  useEffect(() => {
    if (data && data.length > 0 && data.some(item => item.isPublished)) {
      const currentImage = data[currentSlideIndex]
      setMainImageIsPublished(currentImage.isPublished)
    }
    if (data && data.length > 0 && data.some(item => !item.isPublished)) {
      const currentImage = data[currentSlideIndex]
      setMainImageIsPublished(currentImage.isPublished)
    }
  }, [currentSlideIndex, data, onReload])

  useEffect(() => {
    const handlePopState = () => {
      if (onClose) {
        onClose()
      }
    }

    window.history.pushState(null, '', window.location.pathname)
    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [onClose])

  useEffect(() => {
    updateStatusBarColor('#000000')
  }, [])


  return (
    <>
      {modal === 'publish' && onReload && <PublishModal onClose={() => setModal('')} mediaId={mediaId} action={action} onReload={onReload} />}
      {modal === 'delete' && onReload && <DeleteModal onClose={() => setModal('')} mediaId={mediaId} onReload={onReload} />}
      <div className='galleryPopup'>
        <div className='galleryPopup__content'>
          <div className='galleryPopup__content__head'>
            <div className="iconWrap"><i className='icon icon--close s20' onClick={onClose}></i></div>
            <div className="public">
              {!fromPublic &&
                <>
                  {!mainImageIsPublished && data && <div className="wrap" onClick={() => handleAction('publish', data[currentSlideIndex].id)}><i className="icon icon--private s20"></i><span>Prywatne</span></div>}
                  {mainImageIsPublished && data && <div className="wrap" onClick={() => handleAction('unpublish', data[currentSlideIndex].id)}><i className="icon icon--public s20"></i><span>Publiczne</span></div>}
                </>
              }
              {!fromPublic && data && <div className="iconWrap"><i className="icon icon--trash s20" onClick={() => handleAction('delete', data[currentSlideIndex].id)}></i></div>}
            </div>
          </div>
          <div className='galleryPopup__content__body column'>
            {data && <>
              <Swiper
                onSlideChange={handleSlideChange}
                loop
                navigation
                style={style}
                spaceBetween={10}
                initialSlide={initialSlide}
                thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                modules={[FreeMode, Navigation, Thumbs]}
                className='gallery__swiper'>
                {gallery}
              </Swiper>
              <Swiper
                loop
                freeMode
                spaceBetween={10}
                slidesPerView='auto'
                watchSlidesProgress
                onSwiper={setThumbsSwiper}
                modules={[FreeMode, Navigation, Thumbs]}
                className='thumbs__swiper'>
                {thumbsGallery}
              </Swiper>
            </>}
          </div>
        </div>
      </div>
    </>
  )
}

export default SwiperGalleryModal